export default "__VITE_ASSET__CQqsOb8e__"